<template>
  <div class="van-help">
    <div class="van-help__item">
      <a href="javascript:;">
        <div class="service">
          <img class="icon-service" :src="iconUrl" alt="">
          联系客服
        </div>
        <div class="van-help-qrcode">
          <img class="van-help-qrcode__img" src="https://vanthink.oss-cn-qingdao.aliyuncs.com/9a0396ac510f870b6267ac233034ce37.jpg" alt="微信客服">
        </div>
      </a>
    </div>
    <div class="van-help__item">客服值班时间：8:30-22:30（全年无休）</div>
  </div>
</template>

<script>
export default {
  props: {
    iconUrl: {
      type: String,
      default: 'https://vanthink.oss-cn-qingdao.aliyuncs.com/3b718306c41e175c91a9cdf4bf908770.png',
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';

  .van-help {
    font-size: 16px;
    padding: 12px;
    text-align: center;
    color: #949494;
    font-weight: 500;
    a {
      position: relative;
      .service {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      &:hover {
        .van-help-qrcode {
          display: block;
        }
      }
    }
    .van-help__item {
      &:first-child {
        margin-bottom: 10px;
      }
    }
    .van-help-qrcode {
      box-sizing: border-box;
      position: absolute;
      left: -125px;
      bottom: 40px;
      width: 180px;
      height: 180px;
      background-color: #fff;
      box-shadow: 0 0 10px #cecece;
      display: none;
      &:before {
        position: absolute;
        right: 10px;
        bottom: -40px;
        border-top: 24px solid #fff;
        border-right: 18px solid transparent;
        border-bottom: 24px solid transparent;
        border-left: 18px solid transparent;
        filter: drop-shadow(0 0 2px #cecece);
        content: '';
      }
      &:after {
        position: absolute;
        right: 5px;
        bottom: 0;
        width: 50px;
        height: 30px;
        background-color: #fff;
        content: '';
      }
      .van-help-qrcode__img {
        position: relative;
        width: 100%;
        height: 100%;
        z-index: 999;
      }
    }
  }
</style>
